import React, { useRef } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import S from './SearchBoxStyles';

type SearchBoxProps = {
  onPlaceSelected: (place: google.maps.places.PlaceResult) => void;
};

function SearchBox({ onPlaceSelected }: SearchBoxProps): JSX.Element {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

  const handlePlaceChanged = (): void => {
    const place = autocompleteRef.current?.getPlace();
    if (place && place.geometry) {
      onPlaceSelected(place);
    }
  };

  return (
    <S.Wrapper>
      <Autocomplete
        onLoad={(autocomplete): void => { autocompleteRef.current = autocomplete; }}
        onPlaceChanged={handlePlaceChanged}
      >
        <input
          type="text"
          placeholder="Search address"
          style={{ width: '200px', height: '30px', padding: '5px' }}
        />
      </Autocomplete>
    </S.Wrapper>
  );
}

export default SearchBox;
